"use client";

import React, { useState, useRef, useEffect } from "react";
import Image from "next/image";

export default function MagazineReviews({ backgroundColor = "bg-white" }) {
  const quotes = [
    {
      src: "https://gibsonbrands.blob.core.windows.net/gibson-web/app-landing-page/Quote-RollingStone-IMG.webp",
      alt: "RollingStone",
      quote: "The Gibson App Is Changing the Guitar Teaching Game",
    },
    {
      src: "https://gibsonbrands.blob.core.windows.net/gibson-web/app-landing-page/Quote-GuitarWorld-IMG.webp",
      alt: "GuitarWorld",
      quote:
        "For those just starting their guitar journey, the Gibson app will be a godsend. The quality of tuition is second to none.",
    },
    {
      src: "https://gibsonbrands.blob.core.windows.net/gibson-web/app-landing-page/Quote-MusicRadar-IMG.webp",
      alt: "MusicRadar",
      quote: "...That's an example of quite bold innovation",
    },
    {
      src: "https://gibsonbrands.blob.core.windows.net/gibson-web/app-landing-page/Quote-PremierGuitar-IMG.webp",
      alt: "PremierGuitar",
      quote:
        "...This all-in-one app is a deep collection of instructional materials, song tutorials, a tuner, and a progressive learning path",
    },
  ];

  const [current, setCurrent] = useState(0);
  const intervalRef = useRef(null);
  let startX = 0;

  function stopAutoScroll() {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }

  function onTouchStart(e) {
    stopAutoScroll();
    startX = e.touches[0].clientX;
  }

  function onTouchEnd(e) {
    const endX = e.changedTouches[0].clientX;
    if (endX - startX > 50) {
      setCurrent((c) => (c === 0 ? quotes.length - 1 : c - 1));
      stopAutoScroll();
    } else if (startX - endX > 50) {
      setCurrent((c) => (c === quotes.length - 1 ? 0 : c + 1));
      stopAutoScroll();
    }
  }

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setCurrent((c) => (c === quotes.length - 1 ? 0 : c + 1));
    }, 4000);
    return () => stopAutoScroll();
  }, []);

  return (
    <div className={`w-full ${backgroundColor} py-10`}>
      <div className="max-w-screen-lg mx-auto px-4">
        {/* MOBILE */}
        <div
          className="block md:hidden relative overflow-hidden"
          onTouchStart={onTouchStart}
          onTouchEnd={onTouchEnd}
        >
          <div
            className="flex transition-transform duration-300"
            style={{ transform: `translateX(-${current * 100}%)` }}
          >
            {quotes.map((q, i) => (
              <div
                key={i}
                className="flex-none w-full flex flex-col items-center space-y-4 px-4"
              >
                <Image
                  src={q.src}
                  alt={q.alt}
                  width={250}
                  height={100}
                  className="object-contain"
                />
                <p className="text-gray-700 text-[16px] max-w-[400px] text-center">
                  “{q.quote}”
                </p>
              </div>
            ))}
          </div>

          {/* Dots */}
          <div className="flex justify-center mt-4 space-x-2">
            {quotes.map((_, idx) => (
              <button
                key={idx}
                onClick={() => {
                  stopAutoScroll();
                  setCurrent(idx);
                }}
                className={`w-2 h-2 rounded-full transition-all ${
                  idx === current ? "bg-gray-800" : "bg-gray-400"
                }`}
              />
            ))}
          </div>
        </div>

        {/* DESKTOP */}
        <div className="hidden md:grid grid-cols-2 lg:grid-cols-4 gap-8 font-trade_gothic_lt_std">
          {quotes.map((q, i) => (
            <div
              key={i}
              className="flex flex-col items-center justify-start space-y-4"
            >
              <Image
                src={q.src}
                alt={q.alt}
                width={250}
                height={100}
                className="object-contain"
              />
              <p className="text-gray-700 text-[14px] max-w-[400px] text-center">
                “{q.quote}”
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
